import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Canvas URL contract: /canvas?new=1 starts a new graph, /canvas?flow=<id>
 * opens a saved flow. Acts once per parameter value, then removes the
 * parameter from the URL.
 */
export function useCanvasDeepLink({ onNew, onOpenFlow }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const lastHandled = useRef(null);

  useEffect(() => {
    const isNew = searchParams.get('new');
    const flowId = searchParams.get('flow');
    if (!isNew && !flowId) {
      lastHandled.current = null; // param gone: the same value may act again later
      return;
    }
    const key = flowId ? `flow:${flowId}` : `new:${isNew}`;
    if (lastHandled.current === key) return; // StrictMode / re-render before the URL update lands
    lastHandled.current = key;

    const next = new URLSearchParams(searchParams);
    if (flowId) {
      next.delete('flow');
      onOpenFlow?.(flowId);
    } else {
      next.delete('new');
      onNew?.();
    }
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams, onNew, onOpenFlow]);
}
